import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  redirectAndClose() {
    const modalElement = this.element.closest('.modal')
    if (modalElement) {
      const modal = bootstrap.Modal.getOrCreateInstance(modalElement)
      modal.hide()
    }
  }
}
